import {Euler, Vector3} from "three";

export class VectorHelper {

    static DegToRad = Math.PI / 180;
    static RadToDeg = 180 / Math.PI;

    private static convertUnityToThreeCoords(vector: Vector3) {
        return new Vector3(vector.x,vector.y,-vector.z)
    }
    private static normalizeAngle(t : number) {
        let e = t % 360;
        return e > 180 ? e -= 360 : e < -180 && (e += 360),
            e
    }
    private static convertUnityToThreeEuler(vector: Vector3) {
        return new Euler(-VectorHelper.normalizeAngle(vector.x) * VectorHelper.DegToRad,-vector.y * VectorHelper.DegToRad,-vector.z * VectorHelper.DegToRad,"YXZ")
    }

    private static stringToVector3(vectorString: string) {
        const vectorArray = vectorString.split(",").map(Number);
        return new Vector3(vectorArray[0],vectorArray[1],vectorArray[2])
    }

    static stringToThreeVector(str: string) {
        const unityVector = this.stringToVector3(str);
        return this.convertUnityToThreeCoords(unityVector);
    }

    static stringToThreeEuler (str: string) {
        const unityVector = this.stringToVector3(str);
        return this.convertUnityToThreeEuler(unityVector);
    }
}
